"use client";

import { useMixpanel } from "./useMixpanel";

export const useABContext = () => useMixpanel();
